module.exports = __webpack_public_path__ + "img/excellence2.04f83bd7.png";